// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__x198h","search-clear":"Search_search-clear__uIDTy","loading":"Search_loading__rDxS1","action-btn":"Search_action-btn__hlmGw","icon":"Search_icon__xwN3n"};